import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/system/getting-started/the-sx-prop/the-sx-prop.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
